import { useHealth } from "../lib/hooks";

/**
 * Thin banner shown when the admin-backend can't reach its Postgres.
 * Renders nothing when the connection is healthy.
 */
export function ConnectionBanner() {
  const { data, isLoading } = useHealth();
  if (isLoading || !data || data.connected) return null;
  return (
    <div
      role="status"
      style={{
        margin: "0 0 16px",
        padding: "10px 14px",
        borderRadius: 8,
        border: "1px solid color-mix(in oklab, var(--ad-warn) 50%, transparent)",
        background: "color-mix(in oklab, var(--ad-warn) 12%, transparent)",
        color: "var(--ad-fg-1)",
        fontSize: 13,
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <div style={{ fontWeight: 600, color: "var(--ad-warn)" }}>
        Database not reachable. Data may be stale.
      </div>
      <div style={{ fontSize: 11, color: "var(--ad-fg-3)" }}>
        Target: <span className="mono">{data.serverUrl}</span>
        {data.error ? ` · ${data.error}` : ""}
      </div>
    </div>
  );
}
